$(document).ready(function(){
	// Hero.init();
})

$(document).ready(function(){
	// Hero.resize();
})

Hero = {
	minHeight:400,
	el: {},
	init: function(){
		Hero.el = $('#hero');
		// Hero.resize();
		Hero.load();

	},

	resize: function(){
		var height = $(window).innerHeight() - $('.row.header').outerHeight() - 60;
		Hero.el.height(height);
	},

	load: function(){
		var img =  WEB_ROOT+'/templates/images/bg.jpg';
		console.log(img);
		$('<img/>').attr('src', img).load(function() {
		   $(this).remove(); 
		   $('body')
				.css({'background-image':'url('+img+')'})
				.removeClass('hidden');
		});
	}
}